// For filters in pills for map or kanban view
export enum TripStatusFilters {
    ONGOING = 'ongoing',
    DELAYED = 'delayed',
    FINISHED = 'finished',
    CANCELED = 'canceled',
    CLOSED = 'closed',
    PENDING = 'pending',
    ASSIGNED = 'assigned',
    UNASSIGNED = 'unassigned',
}
